import PropTypes from 'prop-types';
import React from 'react';
import { CONTENT_CAPTION_ELEMENT_CLASS_NAME } from '../../constants';

const captionCredit = (__html) =>
  <div className="credit" dangerouslySetInnerHTML={{ __html }} />;

const captionDescription = (__html) =>
  <div className="description" dangerouslySetInnerHTML={{ __html }} />;

const ContentCaption = ({ credit, description }) => (
  <div className={CONTENT_CAPTION_ELEMENT_CLASS_NAME}>
    {credit && captionCredit(credit)}
    {description && captionDescription(description)}
  </div>
);

ContentCaption.propTypes = {
  credit: PropTypes.string,
  description: PropTypes.string
};

export default ContentCaption;
